<div class="main-container" *ngIf="orderItems.length > 0; else noItems">
    @if(isLoading){
    <div *ngIf="isLoading" class="spinner-container">
        <mat-spinner [diameter]="50"></mat-spinner>
    </div>
    }
    <div class="heading-container">
        <div class="left-section">
            <div class="icon-container" (click)="goBack()">
                <mat-icon svgIcon="arrowleft" class="back-icon"></mat-icon>
            </div>

            <div class="title-container">
                <p class="title font-poppins">{{ type }} Items</p>
                <p class="subtitle">{{ heading }}</p>
            </div>
        </div>

        <div class="heading-right-section">
            <mat-checkbox
                class="hidden-checkbox"
                [indeterminate]="isSomeSelected()"
                [checked]="isAllSelected()"
                (change)="toggleSelectAll($event)"
            >
            </mat-checkbox>
            <div class="select-btn-content">
                <button
                    mat-flat-button
                    class="btn-white btn"
                    *ngIf="orderItems.length > 1"
                    (click)="onSelectAllButtonClick()"
                >
                    {{
                        isAllSelected()
                            ? ("orderItemList.button.unselectAll" | translate)
                            : ("orderItemList.button.selectAll" | translate)
                    }}
                </button>
                <button
                    class="btn-white btn"
                    mat-flat-button
                    [disabled]="!selectedItems.size"
                    (click)="navigateReturnReplacePage()"
                >
                    {{ buttonLabel }}
                </button>
            </div>
        </div>
    </div>
    <div class="product-section">
        @for (orderItem of orderItems; let i = $index; track i) {
        <div class="product">
            <div class="checkbox-status">
                <mat-checkbox
                    (change)="toggleSelectItem(orderItem?.id!)"
                    [checked]="selectedItems.has(orderItem?.id!)"
                ></mat-checkbox>
                <p class="status">{{ orderItem.itemStatus }}</p>
            </div>

            <div class="middle-section">
                <img
                    class="product-image"
                    [class]="'product-image-gradient' + ((i % 3) + 1)"
                    [src]="orderItem.product?.images?.imagesUrl?.[0]"
                />
                <p class="product-name font-poppins" appEllipsis maxWidth="80%">
                    {{ orderItem.product?.name }}
                </p>
                <div class="block">
                    <p>
                        {{
                            orderItem.product?.subCategory
                                ? orderItem.product?.subCategory
                                : orderItem.product?.category
                        }}
                    </p>
                    <label *ngIf="orderItem.product?.modelQuantityJson"
                        >{{ orderItem.product?.modelQuantityJson?.totalBlock }} Blocks</label
                    >
                </div>
            </div>

            <div class="bottom-section">
                <div class="left">
                    <p>
                        Quantity: <strong>{{ orderItem.quantity }}</strong>
                    </p>
                    <h3 class="price font-poppins">
                        ₹
                        {{
                            orderItem.product?.discountedPrice
                                ? (orderItem.product?.discountedPrice | number: "1.0-0")
                                : (orderItem.product?.price | number: "1.0-0")
                        }}
                    </h3>
                </div>
                <div class="right">
                    <p>Order ID#{{ orderItem.orderId }}</p>
                </div>
            </div>
        </div>
        }
    </div>
</div>

<ng-template #noItems>
    <div class="empty-state" *ngIf="!isLoading">
        <div class="empty-message-content">
            <mat-icon class="info-icon">info</mat-icon>
            <p class="empty-message">
                {{ "orderItemList.moItem" | translate }}
                {{
                    type === "return"
                        ? ("orderItemList.return" | translate)
                        : type === "exchange"
                        ? ("orderItemList.exchange" | translate)
                        : ("orderItemList.cancel" | translate)
                }}.
            </p>
        </div>
        <button mat-flat-button class="btn-primary-gradient" routerLink="/account/trackOrder">
            {{ "orderItemList.button.back" | translate }}
        </button>
    </div>
</ng-template>
